import { render, staticRenderFns } from "./correctRateHaibao.vue?vue&type=template&id=32edb4ae&scoped=true&"
import script from "./correctRateHaibao.vue?vue&type=script&lang=js&"
export * from "./correctRateHaibao.vue?vue&type=script&lang=js&"
import style0 from "./correctRateHaibao.vue?vue&type=style&index=0&id=32edb4ae&prod&scoped=true&lang=scss&"
import style1 from "./correctRateHaibao.vue?vue&type=style&index=1&id=32edb4ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32edb4ae",
  null
  
)

export default component.exports